import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAWxS7aMVntRzOJVp1gArvpFazf6cpyLFo",
  authDomain: "finemanagmentsystem.firebaseapp.com",
  projectId: "finemanagmentsystem",
  storageBucket: "finemanagmentsystem.firebasestorage.app",
  messagingSenderId: "260850848242",
  appId: "1:260850848242:web:d2f0cfa2bd79459cb61b6b",
  measurementId: "G-1JK2SP9FZN"

  // apiKey: "AIzaSyAcKqyD2LGpCcgBlunkhDBsxM83eRNHo7Y",
  // authDomain: "stgfinecollectionsystem.firebaseapp.com",
  // projectId: "stgfinecollectionsystem",
  // storageBucket: "stgfinecollectionsystem.firebasestorage.app",
  // messagingSenderId: "621233555368",
  // appId: "1:621233555368:web:b46ac9357fa1c3df33ff9d",
  // measurementId: "G-1JK2SP9FZN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export const getUsers = async () => {
  try {
    console.log("Fetching users from Firestore...");
    const usersCollection = collection(db, "users"); // ✅ db must come from getFirestore(app)
    const usersSnapshot = await getDocs(usersCollection);
    const usersList = usersSnapshot.docs.map(doc => ({
      id: doc.id,
      name: doc.data().userName,
      email: doc.data().userEmail,
      role: doc.data().userRole,
      status: doc.data().status || "Active"
    }));
    console.log("Fetched users:", usersList);
    return usersList;
  } catch (error) {
    console.error("Error fetching users: ", error);
    return [];
  }
};

export { db, auth };
